import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { resetView, resetViewsPanel, useViewsPanelState } from 'reducers/viewsSlice';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { BottomDrawer, DrawerBody, DrawerContent, DrawerHeader } from 'uiToolkitV1/BottomDrawer';

import { useDeleteView } from '../Hooks/dataHooks';
import { DeleteViewModal } from './DeleteViewModal';
import { ManageViewsBody } from './ManageViewsBody';
import { ManageViewsHeader } from './ManageViewsHeader';

export const ManageViews = () => {
  const { open } = useViewsPanelState();

  const [viewSelectedInMenu, setViewSelectedInMenu] = useState(null);

  const { isLoading, mutate: deleteView } = useDeleteView();

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(resetViewsPanel());
    dispatch(resetView());
  };

  const deleteHandler = () => {
    deleteView({ viewId: viewSelectedInMenu });
    setViewSelectedInMenu(null);
  };

  useEffect(() => {
    if (open) {
      sendPageViewEvent({
        eventProperties: {
          page: 'Custom Team-manage',
        },
      });
    }
  }, [open]);

  return (
    <>
      <BottomDrawer isOpen={open} onClose={onClose} placement="bottom">
        <DrawerContent width="80%">
          <DrawerHeader onClose={onClose}>
            <ManageViewsHeader />
          </DrawerHeader>
          <DrawerBody>
            <ManageViewsBody setViewSelectedInMenu={setViewSelectedInMenu} />
          </DrawerBody>
        </DrawerContent>
      </BottomDrawer>
      <DeleteViewModal deleteView={deleteHandler} isLoading={isLoading} />
    </>
  );
};
